package com.checkin.host.util

import com.checkin.shared.dto.ReservationDto
import com.checkin.shared.model.GuestStatus

enum class VerificationBadge {
    COMPLETE,
    IN_PROGRESS,
    PENDING,
    MANUAL_REVIEW,
    HOST_REVIEW,
}

fun reservationVerificationBadge(reservation: ReservationDto): VerificationBadge {
    val guests = reservation.guests
    if (guests.isEmpty()) return VerificationBadge.PENDING
    if (guests.any { it.status == GuestStatus.AWAITING_HOST_REVIEW }) {
        return VerificationBadge.HOST_REVIEW
    }
    if (guests.any { it.manualVerificationRequired }) return VerificationBadge.MANUAL_REVIEW
    if (guests.all { it.status == GuestStatus.COMPLETED }) return VerificationBadge.COMPLETE
    if (guests.any { it.status != GuestStatus.PENDING }) return VerificationBadge.IN_PROGRESS
    return VerificationBadge.PENDING
}

fun verificationBadgeLabel(badge: VerificationBadge): String = when (badge) {
    VerificationBadge.COMPLETE -> "Vérification complète"
    VerificationBadge.IN_PROGRESS -> "En cours"
    VerificationBadge.PENDING -> "En attente"
    VerificationBadge.MANUAL_REVIEW -> "Validation nécessaire"
    VerificationBadge.HOST_REVIEW -> "Revue hôte requise"
}
